"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useDialogActions_unstable", {
    enumerable: true,
    get: ()=>useDialogActions_unstable
});
const _interopRequireWildcard = require("@swc/helpers/lib/_interop_require_wildcard.js").default;
const _react = /*#__PURE__*/ _interopRequireWildcard(require("react"));
const _reactUtilities = require("@fluentui/react-utilities");
const useDialogActions_unstable = (props, ref)=>{
    const { position ='end' , fluid =false  } = props;
    return {
        components: {
            root: 'div'
        },
        root: (0, _reactUtilities.getNativeElementProps)('div', {
            ref,
            ...props
        }),
        position,
        fluid
    };
}; //# sourceMappingURL=useDialogActions.js.map

//# sourceMappingURL=useDialogActions.js.map